import * as React from 'react';

export type RecordingVisualMode = 'idle' | 'preparing' | 'recording';

export function RecordingIndicator() {
  const [visualMode, setVisualMode] = React.useState<RecordingVisualMode>('idle');

  React.useEffect(() => {
    const handlePreparing = () => setVisualMode('preparing');
    const handleStart = () => setVisualMode('recording');
    const handleStop = () => setVisualMode('idle');

    window.addEventListener('recording:preparing', handlePreparing);
    window.addEventListener('recording:starting', handlePreparing);
    window.addEventListener('recording:start', handleStart);
    window.addEventListener('recording:stop', handleStop);

    return () => {
      window.removeEventListener('recording:preparing', handlePreparing);
      window.removeEventListener('recording:starting', handlePreparing);
      window.removeEventListener('recording:start', handleStart);
      window.removeEventListener('recording:stop', handleStop);
    };
  }, []);

  const boxShadow =
    visualMode === 'recording'
      ? 'var(--lk-danger3) 0px 0px 0px 3px inset'
      : visualMode === 'preparing'
        ? 'rgba(245, 158, 11, 0.95) 0px 0px 0px 3px inset'
        : 'none';

  return (
    <div
      style={{
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        boxShadow,
        pointerEvents: 'none',
        transition: 'box-shadow 0.2s ease-in-out',
        animation: visualMode === 'preparing' ? 'pulse-preparing 1.5s ease-in-out infinite' : 'none',
      }}
    />
  );
}
